import { useAuth } from "@/auth/auth.ts";
import type { components } from "@/client/backend/zz_schema";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

export type User = components["schemas"]["User"] & {
  organizations: components["schemas"]["Organization"][];
};

export function useUser(): {
  user: User | "loading";
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  error: any;
} {
  const auth = useAuth();
  const { data, error } = useSWR(`/users/${auth.userName}`, () =>
    auth.client.GET("/users/{userName}", {
      params: {
        path: {
          userName: auth.userName,
        },
      },
    }),
  );
  const { data: organizationsData, error: organizationsError } = useSWR(`/users/${auth.userName}/memberships`, () =>
    auth.client.GET("/users/{userName}/memberships", {
      params: {
        path: {
          userName: auth.userName,
        },
      },
    }),
  );
  return {
    user: data?.data && organizationsData?.data ? { ...data.data, organizations: organizationsData.data } : "loading",
    error: error || organizationsError,
  };
}

export function useUpdateUser() {
  const auth = useAuth();

  return useSWRMutation(
    `/users/${auth.userName}`,
    (_, { arg }: { arg: components["schemas"]["UserMutable"] }) =>
      auth.client.PATCH("/users/{userName}", {
        params: {
          path: {
            userName: auth.userName,
          },
        },
        body: arg,
      }),
  );
}
